import type { Scenario } from "../types";

export function exportScenarioToCsv(scenario: Scenario): string {
  const rows: string[] = [];
  rows.push(["key", "value", "group"].join(","));
  const a = scenario.assumptions;
  for (const [k, v] of Object.entries(a)) {
    const val = typeof v === "object" ? JSON.stringify(v) : String(v);
    rows.push([escapeCsv(k), escapeCsv(val), "assumptions"].join(","));
  }
  return rows.join("\n");
}

function escapeCsv(val: string): string {
  if (/[",\n]/.test(val)) return `"${val.replace(/"/g, '""')}"`;
  return val;
}
